import { render, staticRenderFns } from "./dong2.vue?vue&type=template&id=d6461c50&scoped=true&"
import script from "./dong2.vue?vue&type=script&lang=js&"
export * from "./dong2.vue?vue&type=script&lang=js&"
import style0 from "./dong2.vue?vue&type=style&index=0&id=d6461c50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6461c50",
  null
  
)

export default component.exports